import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CotIciPage from "../pages/cotasafe/page";
import LoginPage from "../pages/auth/LoginPage";
import RegisterPage from "../pages/auth/RegisterPage";
import DashboardPage from "../pages/dashboard/page";
import AnalysisPage from "../pages/analysis/page";
import AdminPage from "../pages/admin/page";
import AuthGuard from "../components/feature/AuthGuard";
import AdminGuard from "../components/feature/AdminGuard";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/app",
    element: <CotIciPage />,
  },
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/register",
    element: <RegisterPage />,
  },
  {
    path: "/dashboard",
    element: (
      <AuthGuard>
        <DashboardPage />
      </AuthGuard>
    ),
  },
  {
    path: "/analysis",
    element: (
      <AuthGuard>
        <AnalysisPage />
      </AuthGuard>
    ),
  },
  {
    path: "/admin",
    element: (
      <AdminGuard>
        <AdminPage />
      </AdminGuard>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;